export default __webpack_public_path__ + "static/media/pfp-red.59713342.svg";